import { Link } from "react-router";
import { my_routes } from "../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./memory.css";
import CountUp from "react-countup";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CreateMemoryModal from "./createMemoryModal";
import { useEffect, useState } from "react";
import { getAllMemory } from "../../api/memory";
import { toast } from "sonner";
import { getAllAcademicYear } from "../../api/generalParam";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";
import { getAllCycle } from "../../api/settings";

interface Year {
  id: string;
  label: string;
  status: string;
}

//bouton proteger pour ajouter un memoire
const ProtectedBtnAddMemoire = withPermission(
  (props: any) => (
    <button
      onClick={() => props.setShowCreate(true)}
      className="btn btn-primary d-flex align-items-center"
    >
      <i className="ti ti-square-rounded-plus me-2" />
      Ajouter un mémoire
    </button>
  ),
  [buildPermission(Resource.MEMOIRE, Action.CREATE)],
  "masquer",
);

const MemoryList = () => {
  const routes = my_routes;
  const [allMemories, setAllMemories] = useState<any>([]);
  const [allCycles, setAllCycles] = useState<any>([]);
  const [years, setYears] = useState<Year[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedYearId, setSelectedYearId] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedMention, setSelectedMention] = useState("");

  const [showCreate, setShowCreate] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  //Reload de la liste
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  const fetchAllMemory = async () => {
    try {
      const response = await getAllMemory();
      const memories = Array.isArray(response)
        ? response
        : (response?.data ?? []);
      // console.log("Toutes les mémoires", memories);
      setAllMemories(memories);

      setHasLoaded(true);
      setIsLoading(false);
    } catch (error: any) {
      // console.log("erreur de chargement des mémoires : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );

      // Option: reset les mémoires en cas d'erreur
      setAllMemories([]);
    } finally {
      setIsLoading(false);
      setHasLoaded(true);
    }
  };

  const fetchAllCycle = async () => {
    try {
      const response = await getAllCycle();
      const cycles = Array.isArray(response)
        ? response
        : (response?.data ?? []);
      // console.log("Toutes les cycles: ", cycles);
      setAllCycles(cycles);

      setHasLoaded(true);
      setIsLoading(false);
    } catch (error: any) {
      // console.log("erreur de chargement des mémoires : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );

      // Option: reset les mémoires en cas d'erreur
      setAllMemories([]);
    } finally {
      setIsLoading(false);
      setHasLoaded(true);
    }
  };

  const fetchYears = async () => {
    try {
      const response = await getAllAcademicYear();
      const formattedYears = response.data;
      setYears(formattedYears);

      setHasLoaded(true);
      setIsLoading(false);
    } catch (error: any) {
      // console.log("erreur de chargement des années académiques : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );

      // Option: reset les années académiques en cas d'erreur
      setYears([]);
    } finally {
      setIsLoading(false);
      setHasLoaded(true);
    }
  };

  const getMention = (rawNote: any) => {
    const note = Number(rawNote);
    if (Number.isNaN(note)) return "Non classé";
    if (note < 10) return "Insuffisant";
    if (note < 12) return "Passable";
    if (note < 14) return "Assez bien";
    if (note < 16) return "Bien";
    if (note < 18) return "Très bien";
    return "Excellent";
  };

  const memories = allMemories?.allMemory ?? [];

  const totalMemories = memories.length;
  const totalLicence = memories.filter(
    (m: any) => m?.Class?.Level?.cycle === "Licence",
  ).length;
  const totalMaster = memories.filter(
    (m: any) => m?.Class?.Level?.cycle === "Master",
  ).length;
  const totalDoctorat = memories.filter(
    (m: any) => m?.Class?.Level?.cycle === "Doctorat",
  ).length;

  const filteredMemories = memories.filter((memory: any) => {
    const title = (memory?.title || "").toLowerCase();
    const studentName =
      `${memory?.StudentProfil?.firstname || ""} ${memory?.StudentProfil?.lastname || ""}`.toLowerCase();
    const matricule = (memory?.StudentProfil?.matricule || "").toLowerCase();
    const niveau = (memory?.Class?.Level?.abbreviation || "").toLowerCase();
    const classe = (memory?.Class?.label || "").toLowerCase();
    const note = (memory?.note || "").toLowerCase();
    const mention = getMention(memory?.note || 0).toLowerCase();
    const annee = (
      memory?.Class?.Level?.AcademicYear?.label || ""
    ).toLowerCase();

    const matchesSearch =
      !searchTerm ||
      title.includes(searchTerm.toLowerCase()) ||
      studentName.includes(searchTerm.toLowerCase()) ||
      matricule.includes(searchTerm.toLowerCase()) ||
      niveau.includes(searchTerm.toLowerCase()) ||
      classe.includes(searchTerm.toLowerCase()) ||
      note.includes(searchTerm.toLowerCase()) ||
      mention.includes(searchTerm.toLowerCase()) ||
      annee.includes(searchTerm.toLowerCase());

    const matchesYear =
      !selectedYearId ||
      memory?.Class?.Level?.AcademicYear?.id === selectedYearId;
    const matchesLevel =
      !selectedLevel ||
      (memory?.Class?.Level?.cycle || "").toLowerCase() ===
        selectedLevel.toLowerCase() ||
      (
        memory?.Class?.Level?.TypeLevel?.CycleTypeLevels[0]?.Cycle?.label || ""
      ).toLowerCase() === selectedLevel.toLowerCase();

    const matchesMention =
      !selectedMention || getMention(memory.note) === selectedMention;

    return matchesSearch && matchesYear && matchesLevel && matchesMention;
  });

  useEffect(() => {
    fetchYears();
    fetchAllCycle();
    fetchAllMemory();
  }, [refreshKey]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Bibliothèque/Mémoire</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Documents</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Bibliothèque
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2">
                <ProtectedBtnAddMemoire setShowCreate={setShowCreate} />
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Contenu de la page selectionner */}
          <div className="row">
            {/* Total Students */}
            <div className="col-xxl-3 col-sm-6 d-flex">
              <div className="card flex-fill animate-card border-0">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-warning me-2 p-1">
                      <i className="ti ti-school fs-24" />
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          <CountUp end={totalLicence} />
                        </h2>
                        <span className="badge bg-danger">
                          {totalLicence > 0
                            ? (totalLicence * 100) / totalMemories
                            : 0}
                          %
                        </span>
                      </div>
                      <p>Licence</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Students */}
            {/* Total Teachers */}
            <div className="col-xxl-3 col-sm-6 d-flex">
              <div className="card flex-fill animate-card border-0">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl me-2 bg-info p-1">
                      <i className="ti ti-certificate fs-24" />
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          <CountUp end={totalMaster} />
                        </h2>
                        <span className="badge bg-pending">
                          {totalMaster > 0
                            ? (totalMaster * 100) / totalMemories
                            : 0}
                          %
                        </span>
                      </div>
                      <p>Master</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Teachers */}
            {/* Total Staff */}
            <div className="col-xxl-3 col-sm-6 d-flex">
              <div className="card flex-fill animate-card border-0">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl me-2 bg-success p-1">
                      <i className="ti ti-award fs-24" />
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          <CountUp end={totalDoctorat} />
                        </h2>
                        <span className="badge bg-warning">
                          {totalDoctorat > 0
                            ? (totalDoctorat * 100) / totalMemories
                            : 0}
                          %
                        </span>
                      </div>
                      <p>Doctorat</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Staff */}
            {/* Total Subjects */}
            <div className="col-xxl-3 col-sm-6 d-flex">
              <div className="card flex-fill animate-card border-0">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl me-2 bg-dark p-1">
                      <i className="ti ti-books fs-24" />
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          <CountUp end={totalMemories} />
                        </h2>
                        <span className="badge bg-success">
                          {totalMemories > 0
                            ? (totalMemories * 100) / totalMemories
                            : 0}
                          %
                        </span>
                      </div>
                      <p>Total</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Subjects */}
          </div>
          {/* Filtres & Recherche */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="row g-3 align-items-center">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Rechercher un mémoire..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <select
                    className="form-select"
                    value={selectedYearId}
                    onChange={(e) => setSelectedYearId(e.target.value)}
                  >
                    <option value="">Toutes les années</option>
                    {years?.map((year) => (
                      <option key={year.id} value={year.id}>
                        Année {year.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <select
                    className="form-select"
                    value={selectedLevel}
                    onChange={(e) => setSelectedLevel(e.target.value)}
                  >
                    <option value="">Tous les niveaux</option>
                    {allCycles.map((cycle: any) => (
                      <option key={cycle?.id} value={cycle?.label}>
                        {cycle?.label}
                      </option>
                    ))}
                    {/*<option value="Licence">Licence</option>
                    <option value="Master">Master</option>
                    <option value="Doctorat">Doctorat</option>*/}
                  </select>
                </div>

                <div className="col-md-2">
                  <select
                    className="form-select"
                    value={selectedMention}
                    onChange={(e) => setSelectedMention(e.target.value)}
                  >
                    <option value="">Toutes les mentions</option>
                    <option value="Excellent">Excellent</option>
                    <option value="Très bien">Très bien</option>
                    <option value="Bien">Bien</option>
                    <option value="Assez bien">Assez bien</option>
                    <option value="Passable">Passable</option>
                    <option value="Insuffisant">Insuffisant</option>
                    <option value="Non classé">Non classé</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Liste des mémoires */}

          {(filteredMemories?.length ?? 0) > 0 ? (
            filteredMemories.map((memory: any) => {
              return (
                <div
                  key={memory.id}
                  className="card memory-card-horizontal mb-3"
                >
                  <div className="card-body">
                    <div className="row g-3 align-items-center">
                      {/* Icône fichier */}
                      <div className="col-auto">
                        <ImageWithBasePath
                          src={"assets/img/icons/pdf-02.svg"}
                          alt="File"
                          className="me-2 flex-shrink-0"
                        />
                      </div>

                      {/* Contenu principal */}
                      <div className="col min-w-0">
                        <Link to={`/memoryDetails/${memory.id}`}>
                          <h6 className="fw-semibold mb-1 text-truncate">
                            {memory.title}
                          </h6>
                        </Link>

                        <div className="d-flex flex-wrap gap-3 text-muted small">
                          <span>
                            <i className="ti ti-user me-1" />
                            {memory.StudentProfil.matricule} |{" "}
                            {memory.StudentProfil.firstname}{" "}
                            {memory.StudentProfil.lastname}
                          </span>
                          <span>
                            <i className="ti ti-building me-1" />
                            {memory.Class.Level.abbreviation} -{" "}
                            {memory.Class.label}
                          </span>
                          <span>
                            <i className="ti ti-calendar me-1" />
                            {memory.Class.Level.AcademicYear.label}
                          </span>
                          <span>
                            <i className="ti ti-file-description me-1" />
                            {Number(memory.note).toFixed(2)} (
                            {getMention(memory.note)})
                          </span>
                        </div>
                      </div>

                      {/* Niveau + Actions */}
                      <div className="col-12 col-md-auto text-md-end">
                        <span
                          className={`badge ${memory.Class.Level.cycle === "Licence" ? "bg-warning" : "bg-info"} mb-2`}
                        >
                          {memory.Class.Level.cycle}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="card border-0 shadow-sm">
              <div className="card-body text-center py-5">
                <i className="ti ti-book-off fs-1 text-muted mb-3 d-block" />
                <h6 className="mb-1">Aucun mémoire disponible</h6>
                <p className="text-muted mb-3">
                  Aucun mémoire ne réponds aux critères de recherche pour le
                  moment.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      <CreateMemoryModal
        show={showCreate}
        onClose={() => setShowCreate(false)}
        onSaved={reloadData}
      />
    </>
  );
};

export default MemoryList;
